const STORAGE_KEY = "moo_products_last_tracking_kind";

const normalizeChoice = (value) =>
  value === "resold" || value === "composed" ? value : null;

export const readLastProductTrackingKind = (fallback = null) => {
  const productKind = normalizeChoice(fallback);
  if (productKind) return productKind;
  try {
    const saved = normalizeChoice(window.localStorage.getItem(STORAGE_KEY));
    if (saved) return saved;
  } catch (_error) {
    // Le dialogue reste utilisable si le stockage du navigateur est indisponible.
  }
  return productKind || "composed";
};

export const rememberProductTrackingKind = (choice) => {
  const normalized = normalizeChoice(choice);
  if (!normalized) return false;
  try {
    window.localStorage.setItem(STORAGE_KEY, normalized);
  } catch (_error) {
    // Le choix est déjà enregistré sur le produit côté serveur.
  }
  return true;
};
